module.exports = __webpack_public_path__ + "static/media/User.17267f02.svg";